module.exports = __webpack_public_path__ + "static/media/puig.bdc35621.svg";